import React, { useState } from 'react';
import axios from 'axios';

function App() {
  const [formData, setFormData] = useState({
    umur: '',
    jenis_kelamin: '',
    lokasi: '',
    status_pernikahan: '',
    jenis_kopi: '',
    harga_kopi: '',
    rasa_kopi_yang_disuka: '',
    preferensi_penyajian: '',
    waktu_pembelian: ''
  });

  const [prediction, setPrediction] = useState(null);
  const [predictions, setPredictions] = useState([]); // State untuk menampung semua prediksi
  const [inputHistory, setInputHistory] = useState([]); // State untuk menyimpan history input user
  const [error, setError] = useState(''); // State untuk menampung pesan error

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Validasi khusus untuk harga kopi
    if (name === 'harga_kopi') {
      const numValue = Number(value);
      if (value && (numValue < 10000 || numValue > 60000)) {
        setError('Harga kopi harus antara Rp 10.000 - Rp 60.000');
      } else {
        setError('');
      }
    }
    
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validasi harga sebelum submit
    const hargaKopi = Number(formData.harga_kopi);
    if (hargaKopi < 10000 || hargaKopi > 60000) {
      setError('Harga kopi harus antara Rp 10.000 - Rp 60.000');
      return;
    }
    
    // Simpan input user untuk history
    const currentInput = {
      umur: formData.umur,
      jenis_kelamin: formData.jenis_kelamin,
      lokasi: formData.lokasi,
      status_pernikahan: formData.status_pernikahan,
      jenis_kopi: formData.jenis_kopi,
      harga_kopi: formData.harga_kopi,
      rasa_kopi_yang_disuka: formData.rasa_kopi_yang_disuka,
      preferensi_penyajian: formData.preferensi_penyajian,
      waktu_pembelian: formData.waktu_pembelian
    };
  
    // Wrap all inputs in arrays before sending to FastAPI
    const dataToSend = {
      umur: [formData.umur], // Pastikan semua field berbentuk array
      jenis_kelamin: [formData.jenis_kelamin],
      lokasi: [formData.lokasi],
      status_pernikahan: [formData.status_pernikahan],
      jenis_kopi: [formData.jenis_kopi],
      harga_kopi: [formData.harga_kopi],
      rasa_kopi_yang_disuka: [formData.rasa_kopi_yang_disuka],
      preferensi_penyajian: [formData.preferensi_penyajian],
      waktu_pembelian: [formData.waktu_pembelian],
    };
  
    axios.post('https://server.kopicast.web.id/predict', dataToSend)
      .then(response => {
        const newPrediction = response.data.total_prediksi_frekuensi_pembelian; // Ambil hasil prediksi
        setPrediction(newPrediction); // Tampilkan hasil prediksi terbaru
        setPredictions([...predictions, newPrediction]); // Simpan prediksi di array
        setInputHistory([...inputHistory, currentInput]); // Simpan input user di history
        setError(''); // Reset error message
      })
      .catch(error => {
        console.error("There was an error making the request", error);
      });
  };

  // Fungsi untuk menghitung total dari semua prediksi
  const getTotalPredictions = () => {
    return predictions.reduce((total, current) => total + current, 0);
  };

  // Membuat array untuk opsi umur dari 17-50 tahun
  const generateAgeOptions = () => {
    const ages = [];
    for (let i = 17; i <= 50; i++) {
      ages.push(i);
    }
    return ages;
  };

  // Fungsi untuk menampilkan input history dengan format yang rapi
  const formatInputHistoryItem = (inputData, index) => {
    return `${inputData.umur}, ${inputData.jenis_kelamin}, ${inputData.lokasi}, ${inputData.status_pernikahan}, ${inputData.jenis_kopi}, Rp ${inputData.harga_kopi}, ${inputData.rasa_kopi_yang_disuka}, ${inputData.preferensi_penyajian}, ${inputData.waktu_pembelian}`;
  };

  return (
    <div style={styles.container}>
      <h1 style={styles.title}>Prediksi Jumlah Pembelian Kopi</h1>
      <form style={styles.form} onSubmit={handleSubmit}>
        <label style={styles.label}>Umur:</label>
        <select style={styles.input} name="umur" value={formData.umur} onChange={handleChange} required>
          <option value="">Pilih Umur</option>
          {generateAgeOptions().map(age => (
            <option key={age} value={age}>{age}</option>
          ))}
        </select><br />

        <label style={styles.label}>Jenis Kelamin:</label>
        <select style={styles.input} name="jenis_kelamin" value={formData.jenis_kelamin} onChange={handleChange} required>
          <option value="">Pilih Jenis Kelamin</option>
          <option value="Pria">Pria</option>
          <option value="Wanita">Wanita</option>
        </select><br />

        <label style={styles.label}>Lokasi:</label>
        <select style={styles.input} name="lokasi" value={formData.lokasi} onChange={handleChange} required>
        <option value="">Pilih Lokasi</option>
          <option value="Kecamatan Tegalsari">Kecamatan Tegalsari</option>
          <option value="Kecamatan Simokerto">Kecamatan Simokerto</option>
          <option value="Kecamatan Genteng">Kecamatan Genteng</option>
          <option value="Kecamatan Bubutan">Kecamatan Bubutan</option>
          <option value="Kecamatan Gubeng">Kecamatan Gubeng</option>
          <option value="Kecamatan Gunung Anyar">Kecamatan Gunung Anyar</option>
          <option value="Kecamatan Sukolilo">Kecamatan Sukolilo</option>
          <option value="Kecamatan Tambaksari">Kecamatan Tambaksari</option>
          <option value="Kecamatan Mulyorejo">Kecamatan Mulyorejo</option>
          <option value="Kecamatan Rungkut">Kecamatan Rungkut</option>
          <option value="Kecamatan Tenggilis Mejoyo">Kecamatan Tenggilis Mejoyo</option>
          <option value="Kecamatan Benowo">Kecamatan Benowo</option>
          <option value="Kecamatan Pakal">Kecamatan Pakal</option>
          <option value="Kecamatan Asem Rowo">Kecamatan Asem Rowo</option>
          <option value="Kecamatan Sukomanunggal">Kecamatan Sukomanunggal</option>
          <option value="Kecamatan Tandes">Kecamatan Tandes</option>
          <option value="Kecamatan Sambikerep">Kecamatan Sambikerep</option>
          <option value="Kecamatan Lakarsantri">Kecamatan Lakarsantri</option>
          <option value="Kecamatan Bulak">Kecamatan Bulak</option>
          <option value="Kecamatan Kenjeran">Kecamatan Kenjeran</option>
          <option value="Kecamatan Semampir">Kecamatan Semampir</option>
          <option value="Kecamatan Pabean Cantikan">Kecamatan Pabean Cantikan</option>
          <option value="Kecamatan Krembangan">Kecamatan Krembangan</option>
          <option value="Kecamatan Wonokromo">Kecamatan Wonokromo</option>
          <option value="Kecamatan Wonocolo">Kecamatan Wonocolo</option>
          <option value="Kecamatan Wiyung">Kecamatan Wiyung</option>
          <option value="Kecamatan Karang Pilang">Kecamatan Karang Pilang</option>
          <option value="Kecamatan Jambangan">Kecamatan Jambangan</option>
          <option value="Kecamatan Gayungan">Kecamatan Gayungan</option>
          <option value="Kecamatan Dukuh Pakis">Kecamatan Dukuh Pakis</option>
          <option value="Kecamatan Sawahan">Kecamatan Sawahan</option>
        </select><br />

        <label style={styles.label}>Status Pernikahan:</label>
        <select style={styles.input} name="status_pernikahan" value={formData.status_pernikahan} onChange={handleChange} required>
          <option value="">Pilih Status Pernikahan</option>
          <option value="Belum menikah">Belum menikah</option>
          <option value="Sudah menikah">Sudah menikah</option>
        </select><br />

        <label style={styles.label}>Jenis Kopi:</label>
        <select style={styles.input} name="jenis_kopi" value={formData.jenis_kopi} onChange={handleChange} required>
        <option value="">Pilih Jenis Kopi</option>
          <option value="Kopi Hitam">Kopi Hitam</option>
          <option value="Latte">Latte</option>
          <option value="Kopi Susu">Kopi Susu</option>
          <option value="Espresso">Espresso</option>
          <option value="Cappuccino">Cappuccino</option>
          <option value="Americano">Americano</option>
          <option value="Mocha">Mocha</option>
        </select><br />

        <label style={styles.label}>Harga Kopi:</label>
        <input 
          style={error ? {...styles.inputNumber, ...styles.inputError} : styles.inputNumber} 
          type="number" 
          name="harga_kopi" 
          value={formData.harga_kopi} 
          onChange={handleChange} 
          placeholder="Masukkan harga (Rp 10.000 - Rp 60.000)"
          min="10000"
          max="60000"
          required
        />
        {error && <div style={styles.errorMessage}>{error}</div>}
        <br />

        <label style={styles.label}>Rasa Kopi yang Disuka:</label>
        <select style={styles.input} name="rasa_kopi_yang_disuka" value={formData.rasa_kopi_yang_disuka} onChange={handleChange} required>
          <option value="">Pilih Rasa Kopi</option>
          <option value="Manis">Manis</option>
          <option value="Kecut">Kecut</option>
          <option value="Pahit">Pahit</option>
          <option value="Asam">Asam</option>
        </select><br />

        <label style={styles.label}>Preferensi Penyajian:</label>
        <select style={styles.input} name="preferensi_penyajian" value={formData.preferensi_penyajian} onChange={handleChange} required>
          <option value="">Pilih Preferensi Penyajian</option>
          <option value="Panas">Panas</option>
          <option value="Dingin">Dingin</option>
        </select><br />

        <label style={styles.label}>Waktu Pembelian:</label>
        <select style={styles.input} name="waktu_pembelian" value={formData.waktu_pembelian} onChange={handleChange} required>
          <option value="">Pilih Waktu Pembelian</option>
          <option value="Pagi">Pagi (06.00 - 10.00)</option>
          <option value="Siang">Siang (11.00 - 14.00)</option>
          <option value="Sore">Sore (15.00 - 18.00)</option>
          <option value="Malam">Malam (19.00 - 05.00)</option>
        </select><br />

        <button style={styles.button} type="submit">Prediksi</button>
      </form>
      
      {/* Tampilkan hasil prediksi terbaru */}
      {prediction && (
        <div style={styles.result}>
          <h2>Hasil Prediksi: {prediction}</h2>
        </div>
      )}

      {/* Tampilkan semua prediksi yang tersimpan */}
      {predictions.length > 0 && (
        <div style={styles.savedPredictions}>
          <h3>Semua Hasil Prediksi:</h3>
          <ul>
            {predictions.map((pred, index) => (
              <li key={index}>
                <div>
                  <strong>Prediksi {index + 1}: {pred}</strong>
                </div>
                <div style={styles.inputHistoryItem}>
                  <em>Input: {inputHistory[index] ? formatInputHistoryItem(inputHistory[index]) : "Data tidak tersedia"}</em>
                </div>
              </li>
            ))}
          </ul>
          <h3>Total Semua Jumlah Pembelian: {getTotalPredictions()}</h3>
          
          {/* Rekomendasi yang lebih detail dan visual berdasarkan total prediksi */}
          <div style={styles.recommendationSection}>
            <h3 style={styles.recommendationTitle}>Rekomendasi Kopicast</h3>
            
            {getTotalPredictions() < 48 ? (
              <div style={styles.recommendationCards}>
                <div style={styles.recommendationCard}>
                  <h4>Jenis Kopi</h4>
                  <div style={styles.cardContent}>
                    <p><strong>Prioritas Utama:</strong> Latte</p>
                    <p><strong>Alternatif:</strong> Kopi Susu</p>
                    <p>Konsumen cenderung menyukai minuman kopi dengan cita rasa yang lebih ringan dan memiliki tambahan susu.</p>
                  </div>
                </div>
                
                <div style={styles.recommendationCard}>
                  <h4>Lokasi Pemasaran</h4>
                  <div style={styles.cardContent}>
                    <p><strong>Area Utama:</strong> Kecamatan Genteng</p>
                    <p><strong>Area Pendukung:</strong> Kecamatan Tegalsari, Bubutan</p>
                    <p>Fokus pemasaran di area dengan kepadatan penduduk tinggi dan akses yang mudah.</p>
                  </div>
                </div>
                
                <div style={styles.recommendationCard}>
                  <h4>Segmentasi Produk</h4>
                  <div style={styles.cardContent}>
                    <p><strong>Rasa:</strong> Manis dengan tingkat keasaman seimbang</p>
                    <p><strong>Penyajian:</strong> Dingin (60%), Panas (40%)</p>
                    <p><strong>Harga Optimal:</strong> Rp 15.000 - Rp 20.000</p>
                  </div>
                </div>
                
                <div style={styles.recommendationCard}>
                  <h4>Strategi Waktu</h4>
                  <div style={styles.cardContent}>
                    <p><strong>Waktu Optimal:</strong> Sore (15.00-18.00) dan Malam (19.00-22.00)</p>
                    <p><strong>Strategi Promo:</strong> Happy hour 16.00-18.00</p>
                    <p>Tingkatkan frekuensi pembelian dengan promosi bundling pada jam puncak.</p>
                  </div>
                </div>
              </div>
            ) : (
              <div style={styles.recommendationCards}>
                <div style={styles.recommendationCard}>
                  <h4>Jenis Kopi</h4>
                  <div style={styles.cardContent}>
                    <p><strong>Prioritas Utama:</strong> Mocha dan Kopi Susu</p>
                    <p><strong>Alternatif:</strong> Cappuccino</p>
                    <p>Perluas varian dengan cita rasa yang lebih manis dan creamy untuk meningkatkan loyalitas konsumen.</p>
                  </div>
                </div>
                
                <div style={styles.recommendationCard}>
                  <h4>Lokasi Pemasaran</h4>
                  <div style={styles.cardContent}>
                    <p><strong>Area Utama:</strong> Kecamatan Tegalsari, Bubutan, Simokerto</p>
                    <p><strong>Area Ekspansi:</strong> Kecamatan Wonokromo, Gubeng</p>
                    <p>Tingkatkan penetrasi pasar di area perkantoran dan kampus dengan kepadatan tinggi.</p>
                  </div>
                </div>
                
                <div style={styles.recommendationCard}>
                  <h4>Segmentasi Produk</h4>
                  <div style={styles.cardContent}>
                    <p><strong>Rasa:</strong> Lebih manis dengan sentuhan coklat/karamel</p>
                    <p><strong>Penyajian:</strong> Variasi lebih beragam (panas/dingin)</p>
                    <p><strong>Harga Premium:</strong> Rp 22.000 - Rp 35.000</p>
                  </div>
                </div>
                
                <div style={styles.recommendationCard}>
                  <h4>Strategi Waktu</h4>
                  <div style={styles.cardContent}>
                    <p><strong>Waktu Optimal:</strong> Sore (15.00-18.00) dan Malam (19.00-23.00)</p>
                    <p><strong>Program Loyalitas:</strong> Membership dengan diskon khusus</p>
                    <p>Tingkatkan nilai pembelian dengan strategi upselling dan cross-selling.</p>
                  </div>
                </div>
              </div>
            )}
            
            <div style={styles.insightBox}>
              <h3>Insight Pasar</h3>
              <ul style={styles.insightList}>
                <li>Konsumen dengan usia 22-35 tahun menunjukkan frekuensi pembelian tertinggi</li>
                <li>Preferensi rasa manis lebih dominan di segmen wanita (68%)</li>
                <li>Area dengan tingkat penjualan tertinggi berada di kawasan perkantoran dan kampus</li>
                <li>Waktu puncak pembelian kopi berada di jam 16.00-20.00</li>
              </ul>
            </div>
            
            <p style={styles.fullReportLink}>
              Untuk laporan lengkap dan analisis detail, kunjungi{' '}
              <a href="https://kopicast.web.id/recomendation" target="_blank" rel="noopener noreferrer" style={styles.reportLink}>
                Laporan Kopicast <span style={styles.arrowIcon}>→</span>
              </a>
            </p>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: '#00FFFF',
    backgroundImage: 'url(https://images.unsplash.com/photo-1518553300442-dc00435b8b20?q=80&w=1887&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    fontFamily: 'Arial, sans-serif',
    overflow: 'auto',
    padding: '20px',
    boxSizing: 'border-box',
    animation: 'fadeIn 1s ease-in-out',
  },
  title: {
    fontFamily: 'Futura',
    color: '#ffffff',
    fontSize: '64px',
    marginBottom: '20px',
    transition: 'color 0.4s ease, transform 0.4s ease',
    cursor: 'pointer',
    ':hover': {
      color: '#FF6347',
    },
    textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    maxWidth: '800px',
    padding: '20px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
  },
  form: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    width: '100%',
    maxWidth: '600px',
  },
  label: {
    marginBottom: '10px',
    fontSize: '14px',
    color: '#333',
    fontWeight: 'bold',
  },
  input: {
    marginBottom: '15px',
    padding: '10px',
    width: '100%',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    outline: 'none',
  },
  button: {
    padding: '12px',
    width: '100%',
    backgroundColor: '#28a745',
    color: '#ffffff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 'bold',
    transition: 'background-color 0.3s',
  },
  result: {
    marginTop: '20px',
    color: '#ffffff',
    padding: '20px',
    border: '5px solid white',
    borderRadius: '8px',
    backdropFilter: 'blur(10px)',
    transition: 'background-color 0.4s ease, transform 0.4s ease, border-color 0.4s ease',
    boxShadow: '0 6px 12px rgba(0, 0, 0, 0.15)',
    backgroundColor: 'rgba(40, 167, 69, 0.7)',
    ':hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.7)',
      transform: 'scale(1.02)',
      borderColor: '#FF6347',
    },
  },
  savedPredictions: {
    marginTop: '20px',
    color: '#ffffff',
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    padding: '20px',
    borderRadius: '8px',
    width: '100%',
    maxWidth: '800px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3)',
  },
  inputNumber: {
    marginBottom: '15px',
    padding: '10px',
    fontSize: '14px',
    border: '1px solid #ccc',
    borderRadius: '4px',
    outline: 'none',
    width: '100%',
    boxSizing: 'border-box',
  },
  inputError: {
    border: '1px solid #ff0000',
    backgroundColor: '#ffeeee',
  },
  errorMessage: {
    color: '#ff0000',
    fontSize: '12px',
    marginTop: '-10px',
    marginBottom: '15px',
    fontWeight: 'bold',
  },
  inputHistoryItem: {
    fontSize: '12px',
    color: '#ddd',
    marginBottom: '8px',
    paddingLeft: '10px',
  },
  recommendation: {
    backgroundColor: 'rgba(40, 167, 69, 0.3)',
    padding: '10px',
    borderRadius: '5px',
    marginTop: '15px',
  },
  recommendationSection: {
    marginTop: '30px',
    backgroundColor: 'rgba(25, 25, 25, 0.85)',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 6px 15px rgba(0, 0, 0, 0.4)',
    width: '100%',
  },
  recommendationTitle: {
    color: '#fff',
    fontSize: '24px',
    marginBottom: '20px',
    textAlign: 'center',
    fontWeight: 'bold',
    borderBottom: '2px solid #28a745',
    paddingBottom: '10px',
  },
  recommendationCards: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    gap: '15px',
    marginBottom: '20px',
  },
  recommendationCard: {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderRadius: '8px',
    padding: '15px',
    flex: '1 1 45%',
    minWidth: '250px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.2)',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
    borderLeft: '4px solid #28a745',
  },
  cardContent: {
    marginTop: '10px',
  },
  insightBox: {
    backgroundColor: 'rgba(52, 152, 219, 0.2)',
    borderRadius: '8px',
    padding: '15px',
    marginTop: '25px',
    borderLeft: '4px solid #3498db',
  },
  insightList: {
    paddingLeft: '20px',
    margin: '10px 0',
  },
  fullReportLink: {
    marginTop: '25px',
    textAlign: 'center',
    fontSize: '16px',
  },
  reportLink: {
    color: '#28a745',
    textDecoration: 'none',
    fontWeight: 'bold',
    padding: '8px 15px',
    backgroundColor: 'rgba(255, 255, 255, 0.9)',
    borderRadius: '20px',
    transition: 'all 0.3s ease',
    display: 'inline-block',
    marginTop: '10px',
  },
  arrowIcon: {
    marginLeft: '5px',
  },
  '@media (max-width: 768px)': {
    container: {
        padding: '10px',
        backgroundPosition: 'top',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    title: {
        fontSize: '28px',
        textAlign: 'center',
        marginBottom: '20px',
    },
    content: {
        maxWidth: '90%',
        padding: '15px',
        boxSizing: 'border-box',
    },
    form: {
        width: '100%',
        padding: '15px',
    },
    button: {
        fontSize: '14px',
        width: '100%',
        padding: '12px',
        marginTop: '10px',
    },
    input: {
      fontSize: '12px',
      padding: '8px',
    },
    inputNumber: {
      fontSize: '12px',
      padding: '8px',
      maxWidth: '100%',
    },
    recommendationCards: {
      flexDirection: 'column',
    },
    recommendationCard: {
      minWidth: 'auto',
      width: '100%',
      marginBottom: '10px',
    },
  },
  '@media (max-width: 480px)': {
    container: {
        padding: '8px',
        flexDirection: 'column',
        alignItems: 'center',
    },
    title: {
        fontSize: '20px',
        marginBottom: '10px',
        textAlign: 'center',
    },
    content: {
        maxWidth: '100%',
        padding: '10px',
        marginBottom: '15px',
    },
    form: {
        width: '100%',
        padding: '10px',
        marginBottom: '15px',
    },
    input: {
        fontSize: '12px',
        padding: '6px',
        marginBottom: '10px',
        width: '100%',
    },
    button: {
        padding: '10px',
        fontSize: '12px',
        width: '100%',
        marginTop: '10px',
    },
    savedPredictions: {
        padding: '10px',
        width: '100%',
    },
    result: {
        padding: '10px',
        fontSize: '14px',
        marginTop: '15px',
        textAlign: 'center',
    },
    inputNumber: {
      fontSize: '12px',
      padding: '6px',
      width: '100%',
    },
    inputHistoryItem: {
      fontSize: '10px',
    },
    recommendationTitle: {
      fontSize: '18px',
    },
    recommendationCard: {
      padding: '10px',
      width: '100%',
    },
    insightBox: {
      padding: '10px',
    },
    reportLink: {
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'center',
    },
  },
};

// Tambahkan keyframes ke CSS global Anda
const globalCSS = `
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

// Masukkan keyframes ke dalam DOM
const styleSheet = document.createElement("style");
styleSheet.type = "text/css";
styleSheet.innerText = globalCSS;
document.head.appendChild(styleSheet);

export default App;